// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Annotation, Encounter } from '@medplum/fhirtypes';

export const PHONE_ENCOUNTER_NOTES_URL = 'https://polarissleep.com/fhir/StructureDefinition/phone-encounter-notes';

export function readPhoneEncounterNotes(encounter: Encounter): Annotation[] {
  return (encounter.extension ?? [])
    .filter((extension) => extension.url === PHONE_ENCOUNTER_NOTES_URL && extension.valueAnnotation)
    .map((extension) => extension.valueAnnotation as Annotation);
}

export function setPhoneEncounterNotes(
  encounter: Pick<Encounter, 'extension'>,
  notes: Annotation[]
): Encounter['extension'] {
  return [
    ...(encounter.extension?.filter((extension) => extension.url !== PHONE_ENCOUNTER_NOTES_URL) ?? []),
    ...notes.map((note) => ({ url: PHONE_ENCOUNTER_NOTES_URL, valueAnnotation: note })),
  ];
}
